<template>
  <footer class="footer">
    <div class="footer__wrapper grid">
      <p class="footer__trade-mark">
        Martin Lewis is a registered trade mark belonging to Martin S Lewis.
      </p>
      <nav>
        <ul class="footer__links">
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/site/about-the-site"
              target="_blank"
              rel="noopener"
              >About the Site</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/site/editorial-code"
              target="_blank"
              rel="noopener"
              >MSE's Editorial Code</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/site/moneysavingexpert-finance"
              target="_blank"
              rel="noopener"
              >Site's Funding</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/sitemap/"
              target="_blank"
              rel="noopener"
              >Sitemap</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/site/job-vacancies-and-interns"
              target="_blank"
              rel="noopener"
              >Jobs</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/site/access"
              target="_blank"
              rel="noopener"
              >Accessibility</a
            >
          </li>
          <li>
            <a
              class="footer__link"

              :href="FAQ_URL"
              target="_blank"
              rel="noopener"
              >Email FAQs</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              :href="FAQ_URL"
              target="_blank"
              rel="noopener"
              >Forum Rules</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/site/forum-introduction-guide"
              target="_blank"
              rel="noopener"
              >New to forum?</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              :href="FAQ_URL"
              target="_blank"
              rel="noopener"
              >Site FAQs</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/site/site-contacts"
              target="_blank"
              rel="noopener"
              >Contact us</a
            >
          </li>
          <li>
            <a
              class="footer__link"
              href="https://tunirexun.com/pressreleases"
              target="_blank"
              rel="noopener"
              >Press Releases</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script setup lang="ts">
  import { FAQ_URL } from '@/constants/urls';
</script>

<style scoped lang="scss">
  .footer {
    display: flex;
    justify-content: center;
    background: $black-3;

    @include lg {
      padding: 30px;
    }

    &__wrapper {
      max-width: $max-static-content-width;
    }

    &__trade-mark {
      font-size: remc(15px);
      line-height: remc(24px);
      color: $white;
      text-align: center;
    }

    &__links {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-bottom: 0;

      li {
        margin: 0 12px;
        line-height: remc(24px);
      }
    }

    &__link {
      font-size: remc(10px);
      font-weight: bold;
      color: $white;
      text-decoration: none;
      text-transform: uppercase;

      &:hover {
        color: $white;
      }
    }
  }
</style>
